import axios from "axios";

const hostname = window.location.hostname;

const isLocal =
  hostname === "localhost" ||
  hostname === "127.0.0.1";

const API_BASE_URL = isLocal
  ? "http://localhost:5002/api"
  : "/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// =========================================================
// REQUEST INTERCEPTOR
// =========================================================

api.interceptors.request.use(
  (config) => {
    const requestUrl = config.url || "";

    const isSuperAdminRequest =
      window.location.pathname.startsWith("/superadmin");

    const isSuperAdminLogin =
      requestUrl === "/superadmin/auth/login";

    let token = null;

    if (isSuperAdminRequest) {
      token = localStorage.getItem("superadminToken");
    } else {
      token =
        localStorage.getItem("token") ||
        localStorage.getItem("accessToken");
    }

    // Login itself must not receive an old Authorization header.
    if (isSuperAdminLogin) {
      if (config.headers) {
        delete config.headers.Authorization;
      }
    } else if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// =========================================================
// RESPONSE INTERCEPTOR
// =========================================================

api.interceptors.response.use(
  (response) => response,

  (error) => {
    if (error?.response?.status === 401) {
      const isSuperAdminRequest =
        window.location.pathname.startsWith("/superadmin");

      if (isSuperAdminRequest) {
        localStorage.removeItem("superadminToken");

        if (
          window.location.pathname !==
          "/superadmin/login"
        ) {
          window.location.href =
            "/superadmin/login";
        }
      } else {
        localStorage.removeItem("token");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("user");

        sessionStorage.removeItem("authUser");

        if (
          window.location.pathname !==
          "/login"
        ) {
          window.location.href = "/login";
        }
      }
    }

    return Promise.reject(error);
  }
);

console.log(
  "🚀 EDUCATION AXIOS CONFIG:",
  {
    hostname,
    isLocal,
    baseURL: API_BASE_URL,
  }
);

export default api;